module.exports = __webpack_public_path__ + "img/FormTemplates.c58e6826.svg";